import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, search, nullsafe, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { RecordatorioAcuse } from "../model";


export interface Props extends kea.ModalProps<undefined, boolean, RecordatorioAcuse[]> {
}


/**
* Modal de edición para un FinalizarEntrega
*/
export class RecordarAcusesModal extends React.PureComponent<Props> {
    onOk = () => {
        this.props.onClose(true);
    }
    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const acuses = this.props.params;
        return (
            <kea.Modal
                buttons={[<kea.Button style="success" children="Capturar firma del cliente" onClick={this.onOk}  iconClass={fa("pencil-square-o")}  />]}
                onClose={this.onCerrar}
                title="Entrega de acuses"
                fullScreen={true}
            >
                <h3>Recuerde entregar los siguientes acuses:</h3>
                
                <ul>
                    {
                        acuses.map(x =>
                            <li>
                                <h4>
                                <span style={{fontFamily: "monospace"}} ><b>{x.folio}</b></span>{" - "}
                                {
                                    x.tipoAcuse == models.TipoAcuse.Interno ? "Interno" :
                                       ("Externo (" +  x.requerimientoAcuse + ")")
                                }
                                </h4>
                            </li>
                        )
                    }
                </ul>
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/entrega/finalizar/acuses.tsx